<template>
  <div>
    <div
      :class="['answer-group', { fade: !config.isOpen && !isSelect(config.ans) }]"
      :style="{ left: config.posList.x + 'px', top: +config.posList.y + 'px' }"
    >
      <fieldset
        v-for="(a, i) in config.ans"
        :key="'ans' + i"
        :name="config.id + '-a-' + a"
        @click="selectAnswer(a)"
        :class="[
          { fade: (!isCorrect(a) && config.block) || (!config.isOpen && !checkSelect(a)) },
          { fieldsetShow: config.isOpen || checkSelect(a) },
        ]"
        :style="[
          isMoved(i) === true
            ? { position: 'fixed', left: config.posAns.x + 'px', top: config.posAns.y + 'px' }
            : false,
        ]"
      >
        <input
          type="radio"
          :id="config.id + '-a-' + a"
          :value="a"
          :name="config.id"
          :checked="checkSelect(a)"
          :disabled="isCorrect(a)"
          :class="[{ wrong: config.showWrong && checkSelect(a) }]"
        />
        <label :for="config.id + '-a-' + a">{{ answers[a] }}</label>
      </fieldset>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'mp-choose-list-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    answers: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {
    selectAnswer(i) {
      this.$emit('move', this.config.point, true);
      if (!this.config.block) {
        this.config.val = i;
        this.config.checks = false;
      }
      this.resetCheckStatus();
    },
    isMoved(ix) {
      var flg = 0,
        self = this;
      this.config.ans.forEach(function (a, i) {
        if (i !== ix && ((!self.isCorrect(a) && self.config.block) || (!self.config.isOpen && !self.checkSelect(a))))
          flg++;
      });

      return flg === this.config.ans.length - 1;
    },
    isCorrect(a) {
      if (!this.config.checks || this.config.val === null) this.config.isCorrect = 0;
      else {
        if (this.config.val === this.config.cor) {
          this.config.isCorrect = 1;
          this.config.isOpen = true;
          this.config.block = true;
        } else {
          this.config.isCorrect = 2;
        }
      }

      if (this.config.isCorrect == 1 && a == this.config.val) return true;
      return false;
    },
    isSelect(ans) {
      var self = this;
      var flg = false;
      ans.forEach(function (a, i) {
        flg = !flg ? self.checkSelect(a) : flg;
      });
      return flg;
    },
    checkSelect(i) {
      if (this.config.val == null) return false;
      return this.config.val == i;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
input[type='radio'] {
  position: absolute;
  visibility: hidden;
  display: none;
}

label {
  color: black;
  background-color: #dad9d7;
  display: block;
  cursor: pointer;
  text-align: left;
  padding: 0px 20px;
}

input[type='radio']:disabled + label {
  color: black;
  background-color: hsla(150, 75%, 50%, 1) !important;
  cursor: not-allowed;
}

input[type='radio']:checked + label {
  color: black;
  background: #139ed7;
}

input[type='radio'].wrong + label {
  color: white;
  background-color: rgba(196, 29, 29, 1);
}

.answer-group {
  display: inline-block;
  overflow: hidden;
  position: absolute;
  opacity: 1;
  transition: opacity 1s;
}

.fieldsetShow {
  opacity: 1;
  transition: opacity 1s;
}

.fade {
  opacity: 0;
}
</style>
